import CircularProgress from 'material-ui/CircularProgress';
import React, { Component } from 'react';
import autoBind from 'react-autobind';
import { connect } from 'react-redux';
import { Entities, fetchById, getUpdatedEntity, patch, save } from 'src/common/index';
import ErrorMessage from 'src/components/misc/error-message';
import EquipmentEditForm from 'src/components/admin/equipments/equipment-edit-form';

class EquipmentEditModal extends Component {
    constructor(props) {
        super(props);
        autoBind(this);

        this.state = {
            startedFetching: false,
        };
    }

    componentWillMount() {
        const { isCreate, id } = this.props;

        if (!isCreate) this.props.fetchById(id, Entities.BUS_EQUIPMENT);
        else this.setState({ startedFetching: true });
    }

    componentWillReceiveProps(nextProps) {
        const { equipment } = nextProps;

        if (!this.state.startedFetching && equipment.isFetching) this.setState({ startedFetching: true });
    }

    callSubmit() {
        return this.childForm.submit();
    }

    didFormChange() {
        return !this.childForm.pristine;
    }

    render() {
        const { equipment, isCreate, t } = this.props;

        const finishFetching = this.state.startedFetching && !equipment.isFetching;

        if (finishFetching) {
            // check for errors
            if (equipment.error) return <ErrorMessage object={equipment} />;
            // if everything is ok populate form
            else {
                let initialValues = {
                    bestOption: false,
                };

                // populate form for editing an existing equipment
                if (!isCreate && equipment.content)
                    initialValues = {
                        id: equipment.content.id,
                        name: equipment.content.name,
                        rating: equipment.content.rating || 0,
                        bestOption: equipment.content.bestOption || false,
                    };

                return (
                    <EquipmentEditForm
                        initialValues={initialValues}
                        onSubmit={this.handleSubmit}
                        equipment={equipment.content}
                        t={t}
                        ref={ref => (this.childForm = ref)}
                    />
                );
            }
        } else return <CircularProgress />;
    }

    /**
     * Submit form data to backend
     * @param data
     */
    handleSubmit(data) {
        const { isCreate, handleClose } = this.props;

        if (!isCreate) this.props.patch(data, Entities.BUS_EQUIPMENT);
        else this.props.save(data, Entities.BUS_EQUIPMENT);

        handleClose();
    }
}

const mapStateToProps = state => {
    return {
        equipment: getUpdatedEntity(state, Entities.BUS_EQUIPMENT),
    };
};

export default connect(mapStateToProps, { fetchById, patch, save }, null, { withRef: true })(EquipmentEditModal);
